import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { myGuidesAdminApi } from '../services/my-guides-admin-api';

/** Fewest characters worth sending: the backend refuses anything shorter. */
export const MIN_SEARCH_LENGTH = 3;

/**
 * Prefix search of Tripsby users by email (backend proxies Orchestrator).
 * Waits 300 ms after the last keystroke, and stays idle until there are
 * enough characters.
 */
export function usePersonSearch(query: string, enabled = true) {
  const normalized = query.trim().toLowerCase();
  const [debounced, setDebounced] = useState(normalized);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(normalized), 300);
    return () => clearTimeout(timer);
  }, [normalized]);

  const active = enabled && debounced.length >= MIN_SEARCH_LENGTH;
  const result = useQuery(['orchestratorPersonSearch', debounced], () => myGuidesAdminApi.searchStaffPeople(debounced), {
    enabled: active,
    retry: false,
    staleTime: 30 * 1000,
  });

  return { ...result, active, term: debounced, pending: normalized !== debounced };
}
